/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ProposalRenderRouteImport } from './routes/proposal-render'
import { Route as NewRouteImport } from './routes/new'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProposalBuilderIndexRouteImport } from './routes/proposal-builder/index'
import { Route as ProposalBuilderTemplatesRouteImport } from './routes/proposal-builder/templates'
import { Route as ProposalBuilderSetupRouteImport } from './routes/proposal-builder/setup'
import { Route as ProposalBuilderNewRouteImport } from './routes/proposal-builder/new'
import { Route as ProposalBuilderIdRouteImport } from './routes/proposal-builder/$id'
import { Route as ProposalBuilderTemplatesIndexRouteImport } from './routes/proposal-builder/templates/index'
import { Route as ProposalBuilderTemplatesNewRouteImport } from './routes/proposal-builder/templates/new'
import { Route as ProposalBuilderTemplatesIdRouteImport } from './routes/proposal-builder/templates/$id'
import { Route as ProposalBuilderIdViewRouteImport } from './routes/proposal-builder/$id.view'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalRenderRoute = ProposalRenderRouteImport.update({
  id: '/proposal-render',
  path: '/proposal-render',
  getParentRoute: () => rootRouteImport,
} as any)
const NewRoute = NewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalBuilderIndexRoute = ProposalBuilderIndexRouteImport.update({
  id: '/proposal-builder/',
  path: '/proposal-builder/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalBuilderTemplatesRoute =
  ProposalBuilderTemplatesRouteImport.update({
    id: '/proposal-builder/templates',
    path: '/proposal-builder/templates',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProposalBuilderSetupRoute = ProposalBuilderSetupRouteImport.update({
  id: '/proposal-builder/setup',
  path: '/proposal-builder/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalBuilderNewRoute = ProposalBuilderNewRouteImport.update({
  id: '/proposal-builder/new',
  path: '/proposal-builder/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalBuilderIdRoute = ProposalBuilderIdRouteImport.update({
  id: '/proposal-builder/$id',
  path: '/proposal-builder/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalBuilderTemplatesIndexRoute =
  ProposalBuilderTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProposalBuilderTemplatesRoute,
  } as any)
const ProposalBuilderTemplatesNewRoute =
  ProposalBuilderTemplatesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProposalBuilderTemplatesRoute,
  } as any)
const ProposalBuilderTemplatesIdRoute =
  ProposalBuilderTemplatesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ProposalBuilderTemplatesRoute,
  } as any)
const ProposalBuilderIdViewRoute = ProposalBuilderIdViewRouteImport.update({
  id: '/view',
  path: '/view',
  getParentRoute: () => ProposalBuilderIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/proposal-render': typeof ProposalRenderRoute
  '/settings': typeof SettingsRoute
  '/proposal-builder/$id': typeof ProposalBuilderIdRouteWithChildren
  '/proposal-builder/new': typeof ProposalBuilderNewRoute
  '/proposal-builder/setup': typeof ProposalBuilderSetupRoute
  '/proposal-builder/templates': typeof ProposalBuilderTemplatesRouteWithChildren
  '/proposal-builder/': typeof ProposalBuilderIndexRoute
  '/proposal-builder/$id/view': typeof ProposalBuilderIdViewRoute
  '/proposal-builder/templates/$id': typeof ProposalBuilderTemplatesIdRoute
  '/proposal-builder/templates/new': typeof ProposalBuilderTemplatesNewRoute
  '/proposal-builder/templates/': typeof ProposalBuilderTemplatesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/proposal-render': typeof ProposalRenderRoute
  '/settings': typeof SettingsRoute
  '/proposal-builder/$id': typeof ProposalBuilderIdRouteWithChildren
  '/proposal-builder/new': typeof ProposalBuilderNewRoute
  '/proposal-builder/setup': typeof ProposalBuilderSetupRoute
  '/proposal-builder': typeof ProposalBuilderIndexRoute
  '/proposal-builder/$id/view': typeof ProposalBuilderIdViewRoute
  '/proposal-builder/templates/$id': typeof ProposalBuilderTemplatesIdRoute
  '/proposal-builder/templates/new': typeof ProposalBuilderTemplatesNewRoute
  '/proposal-builder/templates': typeof ProposalBuilderTemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/proposal-render': typeof ProposalRenderRoute
  '/settings': typeof SettingsRoute
  '/proposal-builder/$id': typeof ProposalBuilderIdRouteWithChildren
  '/proposal-builder/new': typeof ProposalBuilderNewRoute
  '/proposal-builder/setup': typeof ProposalBuilderSetupRoute
  '/proposal-builder/templates': typeof ProposalBuilderTemplatesRouteWithChildren
  '/proposal-builder/': typeof ProposalBuilderIndexRoute
  '/proposal-builder/$id/view': typeof ProposalBuilderIdViewRoute
  '/proposal-builder/templates/$id': typeof ProposalBuilderTemplatesIdRoute
  '/proposal-builder/templates/new': typeof ProposalBuilderTemplatesNewRoute
  '/proposal-builder/templates/': typeof ProposalBuilderTemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/new'
    | '/proposal-render'
    | '/settings'
    | '/proposal-builder/$id'
    | '/proposal-builder/new'
    | '/proposal-builder/setup'
    | '/proposal-builder/templates'
    | '/proposal-builder/'
    | '/proposal-builder/$id/view'
    | '/proposal-builder/templates/$id'
    | '/proposal-builder/templates/new'
    | '/proposal-builder/templates/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/new'
    | '/proposal-render'
    | '/settings'
    | '/proposal-builder/$id'
    | '/proposal-builder/new'
    | '/proposal-builder/setup'
    | '/proposal-builder'
    | '/proposal-builder/$id/view'
    | '/proposal-builder/templates/$id'
    | '/proposal-builder/templates/new'
    | '/proposal-builder/templates'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/new'
    | '/proposal-render'
    | '/settings'
    | '/proposal-builder/$id'
    | '/proposal-builder/new'
    | '/proposal-builder/setup'
    | '/proposal-builder/templates'
    | '/proposal-builder/'
    | '/proposal-builder/$id/view'
    | '/proposal-builder/templates/$id'
    | '/proposal-builder/templates/new'
    | '/proposal-builder/templates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  NewRoute: typeof NewRoute
  ProposalRenderRoute: typeof ProposalRenderRoute
  SettingsRoute: typeof SettingsRoute
  ProposalBuilderIdRoute: typeof ProposalBuilderIdRouteWithChildren
  ProposalBuilderNewRoute: typeof ProposalBuilderNewRoute
  ProposalBuilderSetupRoute: typeof ProposalBuilderSetupRoute
  ProposalBuilderTemplatesRoute: typeof ProposalBuilderTemplatesRouteWithChildren
  ProposalBuilderIndexRoute: typeof ProposalBuilderIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal-render': {
      id: '/proposal-render'
      path: '/proposal-render'
      fullPath: '/proposal-render'
      preLoaderRoute: typeof ProposalRenderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal-builder/': {
      id: '/proposal-builder/'
      path: '/proposal-builder'
      fullPath: '/proposal-builder/'
      preLoaderRoute: typeof ProposalBuilderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal-builder/templates': {
      id: '/proposal-builder/templates'
      path: '/proposal-builder/templates'
      fullPath: '/proposal-builder/templates'
      preLoaderRoute: typeof ProposalBuilderTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal-builder/setup': {
      id: '/proposal-builder/setup'
      path: '/proposal-builder/setup'
      fullPath: '/proposal-builder/setup'
      preLoaderRoute: typeof ProposalBuilderSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal-builder/new': {
      id: '/proposal-builder/new'
      path: '/proposal-builder/new'
      fullPath: '/proposal-builder/new'
      preLoaderRoute: typeof ProposalBuilderNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal-builder/$id': {
      id: '/proposal-builder/$id'
      path: '/proposal-builder/$id'
      fullPath: '/proposal-builder/$id'
      preLoaderRoute: typeof ProposalBuilderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal-builder/templates/': {
      id: '/proposal-builder/templates/'
      path: '/'
      fullPath: '/proposal-builder/templates/'
      preLoaderRoute: typeof ProposalBuilderTemplatesIndexRouteImport
      parentRoute: typeof ProposalBuilderTemplatesRoute
    }
    '/proposal-builder/templates/new': {
      id: '/proposal-builder/templates/new'
      path: '/new'
      fullPath: '/proposal-builder/templates/new'
      preLoaderRoute: typeof ProposalBuilderTemplatesNewRouteImport
      parentRoute: typeof ProposalBuilderTemplatesRoute
    }
    '/proposal-builder/templates/$id': {
      id: '/proposal-builder/templates/$id'
      path: '/$id'
      fullPath: '/proposal-builder/templates/$id'
      preLoaderRoute: typeof ProposalBuilderTemplatesIdRouteImport
      parentRoute: typeof ProposalBuilderTemplatesRoute
    }
    '/proposal-builder/$id/view': {
      id: '/proposal-builder/$id/view'
      path: '/view'
      fullPath: '/proposal-builder/$id/view'
      preLoaderRoute: typeof ProposalBuilderIdViewRouteImport
      parentRoute: typeof ProposalBuilderIdRoute
    }
  }
}

interface ProposalBuilderIdRouteChildren {
  ProposalBuilderIdViewRoute: typeof ProposalBuilderIdViewRoute
}

const ProposalBuilderIdRouteChildren: ProposalBuilderIdRouteChildren = {
  ProposalBuilderIdViewRoute: ProposalBuilderIdViewRoute,
}

const ProposalBuilderIdRouteWithChildren =
  ProposalBuilderIdRoute._addFileChildren(ProposalBuilderIdRouteChildren)

interface ProposalBuilderTemplatesRouteChildren {
  ProposalBuilderTemplatesIdRoute: typeof ProposalBuilderTemplatesIdRoute
  ProposalBuilderTemplatesNewRoute: typeof ProposalBuilderTemplatesNewRoute
  ProposalBuilderTemplatesIndexRoute: typeof ProposalBuilderTemplatesIndexRoute
}

const ProposalBuilderTemplatesRouteChildren: ProposalBuilderTemplatesRouteChildren =
  {
    ProposalBuilderTemplatesIdRoute: ProposalBuilderTemplatesIdRoute,
    ProposalBuilderTemplatesNewRoute: ProposalBuilderTemplatesNewRoute,
    ProposalBuilderTemplatesIndexRoute: ProposalBuilderTemplatesIndexRoute,
  }

const ProposalBuilderTemplatesRouteWithChildren =
  ProposalBuilderTemplatesRoute._addFileChildren(
    ProposalBuilderTemplatesRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  NewRoute: NewRoute,
  ProposalRenderRoute: ProposalRenderRoute,
  SettingsRoute: SettingsRoute,
  ProposalBuilderIdRoute: ProposalBuilderIdRouteWithChildren,
  ProposalBuilderNewRoute: ProposalBuilderNewRoute,
  ProposalBuilderSetupRoute: ProposalBuilderSetupRoute,
  ProposalBuilderTemplatesRoute: ProposalBuilderTemplatesRouteWithChildren,
  ProposalBuilderIndexRoute: ProposalBuilderIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
